import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type Props = {
  open: boolean;
  userName: string;
  isSubmitting: boolean;
  onSend: () => Promise<void> | void;
  onLater: () => void;
};

const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: 400,
  },
  sendButton: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export function EcoWelcomeDialog({ open, userName, isSubmitting, onSend, onLater }: Props) {
  const classes = useStyles();

  const handleLater = () => {
    if (isSubmitting) return;
    onLater();
  };

  return (
    <Dialog open={open} onClose={handleLater} classes={{ paper: classes.paper }} disableEscapeKeyDown={isSubmitting}>
      <DialogTitle>Prévenir le client par mail ?</DialogTitle>
      <DialogContent>
        <DialogContentText>Un mail de bienvenue éco-acteur sera envoyé à {userName}.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={handleLater} disabled={isSubmitting}>
          Plus tard
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.sendButton}
          onClick={() => onSend()}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} /> : null}
        >
          Envoyer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
